export const renderImageHandler = (obj, locale) => {
  return obj?.['img-' + locale]?.startsWith(process.env.NEXT_PUBLIC_HOME_IMG_BASEURL)
    ? obj['img-' + locale]
    : `${process.env.NEXT_PUBLIC_HOME_IMG_BASEURL}/${obj?.['img-' + locale]}`;
};
